<template>
  <div>
    <div class="img-box c-f-ar">
      <img
        class="img"
        src="@/assets/images/mCard.png"
        alt=""
        srcset=""
      >
    </div>
    <div class="c-ct ">绑定实体会员卡</div>
    <van-field
      v-model="idCard"
      type="number"
      name=""
      label=""
      placeholder="请输入会员卡"
    >
      <template #left-icon>
        <img
          class="c-svg c-m-r-10"
          src="@/assets/images/mCard.png"
          alt=""
          srcset=""
        >
      </template>
    </van-field>
    <van-field
      v-model="phone"
      name=""
      label=""
      placeholder="请输入手机号"
    >
      <template #left-icon>
        <img
          class="c-svg c-m-r-10"
          src="@/assets/images/phone_icon.png"
          alt=""
          srcset=""
        >
      </template>
      <template #right-icon>
        <van-button
          type="info"
          disabled
          round
          size="small"
        >获取验证码</van-button>
      </template>
    </van-field>
    <van-field
      v-model="code"
      name=""
      label=""
      placeholder="请输入验证码"
    >
      <template #left-icon>
        <img
          class="c-svg c-m-r-10"
          src="@/assets/images/pwd_icon.png"
          alt=""
          srcset=""
        >
      </template>
    </van-field>
    <g-bottom-btn
      @click="confirmBind"
      title="确认绑定"
    ></g-bottom-btn>
  </div>
</template>

<script>
export default {
  name: "BindCard",
  props: {

  },
  data() {
    return {
      idCard: '',
      phone: '',
      code: '',
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    confirmBind() {
      this.$toast('请输入会员卡号');
    }
  }
};
</script>
<style scoped lang='scss'>
.img-box {
  width: 160px;
  height: 160px;
  background: rgba(111, 111, 111, 0.1);
  border-radius: 50%;
  margin: 40px auto;
}
.img {
  margin: 40px 0;
  width: 100px;
  height: 100px;
  object-fit: contain;
}
</style>
